<template>
<v-container fluid>
<v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="-1"
  absolute
  >
  {{ message }}
  <v-btn
    dark
    text
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
 </v-snackbar>

  <v-layout class="main-layout">
  <v-flex xs12>
    <v-card>
      <v-card-text>
        <v-layout>
          <v-flex xs3>
            <span class="accent--text" style="font-size: 14px; font-weight:700;"> Buyer Report </span>
            <v-spacer v-if="userId"></v-spacer>
          </v-flex>
          <v-spacer>
          </v-spacer>
          <v-spacer>
          </v-spacer>
          <v-flex xs3>
            <v-btn color="primary" @click="exportToExcel" style="margin-top: 10px;">Export to Excel</v-btn>
          </v-flex>
          <v-flex xs3>
            <v-text-field label="Search" v-model="search">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs3>
            <v-select
              label="Seasons"
              item-text="name"
              item-value="value"
              v-model="season"
              :items="seasons"
              variant="solo-filled"
              solo
              hide-details
              return-object
              dense
            ></v-select>
            <label class="custom-form-error grower-error" for="contract"></label>
          </v-flex>
          <v-flex xs3>
            <v-select
              label="Sales"
              item-text="name"
              item-value="value"
              v-model="sale"
              :items="sales"
              variant="solo-filled"
              solo
              hide-details
              return-object
              dense
            ></v-select>
            <label class="custom-form-error grower-error" for="contract"></label>
          </v-flex>
          <v-flex xs3>
            <v-btn color="#7BC243" @click="getBuyerReport()" class="white--text cataloguebtn">Submit </v-btn>
          </v-flex>
          <v-spacer>
          </v-spacer>
          <!--              <v-flex xs3>
                          <v-text-field label="Search" v-model="search">
                          </v-text-field>
                        </v-flex>-->
        </v-layout>
        <br/>
        <v-data-table
          :headers="headers"
          :items="millingCharges"
          :items-per-page="5"
          :search="search"
          class="elevation-1"
        >
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>

  </v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import http from '../../../http'
import { mapState } from 'vuex'
import * as XLSX from 'xlsx'

export default {
	name: 'catalogueupload',
	data: function () {
		return {
			gradeDisabled: true,
			millingCharges: [],
			editFarmerType: {},
			editCoffeeType: {},
			editGrade: {},
			editStatus: '',
			cherryRateTemp: { rate: 0, name: 'hello' },
			headers: [
				{ text: 'Eslip Number', value: 'e_SLIP_NUMBER' },
				{ text: 'Season', value: 'season' },
				{ text: 'Sale Number', value: 'sale_NUMBER' },
				{ text: 'Invoice Number', value: 'invoiceid' },
				{ text: 'Penalty Due', value: 'penalty_DUE' },
				{ text: 'Weight Bought', value: 'weight_BOUGHT' },
				{ text: 'Buyer Name', value: 'organisation_NAME' },
				{ text: 'Bags', value: 'total_NUMBER_OF_BAGS' },
				{ text: 'Invoice Amount', value: 'invoice_AMOUNT' },
				{ text: 'Invoice Status', value: 'status_NAME' },
				{ text: 'Warrant Number', value: 'warrant_NUMBER' }
			],
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			file: '',
			files: [],
			pagination: { sortBy: 'id', descending: true },
			search: '',
			permissions: [],
			previewLoading: false,
			approveloading: false,
			declineloading: false,
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			confirmDialog: false,
			confirmFile: {},
			confirmMessage: '',
			action: '',
			rateLimitDialog: false,
			editRateLimitDialog: false,
			approveRateLimitDialog: false,
			userID: 0,
			organisationType: null,
			sale: '',
			sales: [],
			season: '',
			seasons: []
		}
	},
	mounted () {
		// this.getBrokerReport()
		this.getSeasons()
		this.permissions = store.state.user.roleId.permissions
	},
	watch: {
		files () {
			this.paginatedFiles = this.paginationMethod(this.files, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		...mapState({ user: state => state.user }),
		canApproveCatalogue: function () {
			return this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.files.filter(file => { return file.fileName.toLowerCase().includes(this.search.toLowerCase()) })
			}
		},
		userId: function () {
			if (this.user) {
				console.log('user - ', this.user)
				this.organisationType = this.user.organisation.organisationType.name
				this.userID = this.user.id
				return this.user.id
			}
			return 0
		}
	},
	methods: {
		canBeApproved (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		canBeDeclined (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		openCreateDialog () {
			this.rateLimitDialog = true
		},
		getBuyerReport () {
			console.log(this.sale)
			console.log(this.season)

			if (this.sale === '' || this.season === '') {
				this.message = 'Please select both season and sale'
				this.snackbar = true
				this.snackbarColor = 'error'
				return
			}
			this.findBuyerReport(this.season.name, this.sale.name)
		},
		findBuyerReport (season, sale) {
			http.get(config.serverURI + '/miller/findBuyers?season=' + season + '&sale=' + sale)
				.then(response => {
					this.millingCharges = response.data
					console.log('RR -> ', response.data)
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		},
		exportToExcel () {
			const exportData = this.millingCharges.map(transaction => ({
				'Eslip Number': transaction.e_SLIP_NUMBER,
				Season: transaction.season,
				'Sale Number': transaction.sale_NUMBER,
				'Invoice Number': transaction.invoiceid,
				'Penalty Due': transaction.penalty_DUE,
				'Weight Bought': transaction.weight_BOUGHT,
				'Buyer Name': transaction.organisation_NAME,
				Bags: transaction.total_NUMBER_OF_BAGS,
				'Invoice Amount': transaction.invoice_AMOUNT,
				'Invoice Status': transaction.status_NAME,
				'Warrant Number': transaction.warrant_NUMBER
				// Add more fields as needed
			}))
			const worksheet = XLSX.utils.json_to_sheet(exportData)
			const workbook = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(workbook, worksheet, 'BuyerData')
			const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
			this.saveExcelFile(excelBuffer, 'buyer_report.xlsx')
		},
		saveExcelFile (buffer, fileName) {
			const data = new Blob([buffer], { type: 'application/octet-stream' })
			const url = window.URL.createObjectURL(data)
			const a = document.createElement('a')
			a.href = url
			a.download = fileName
			a.click()
			window.URL.revokeObjectURL(url)
		},
		getSeasons () {
			http.get(config.serverURI + '/miller/findSeasons')
				.then(response => {
					console.log('seasons => ', response.data)
					response.data.forEach((x) => {
						this.seasons.push({
							name: x,
							value: x
						})
					})
					this.getSales()
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		},
		getSales () {
			http.get(config.serverURI + '/miller/findSales')
				.then(response => {
					console.log('sales => ', response.data)
					response.data.forEach((x) => {
						this.sales.push({
							name: x,
							value: x
						})
					})
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		}
	}
}

</script>
<style>
.main-layout {
  margin-top: 15px;
}
.farmers_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.btn{
  padding: 10px;
  margin: 5px;
}
.farmers_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table  tbody  tr >  td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733D29;
}

.pagination>li>a,
.pagination>li>span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}
.pagination>li.active>.page-link {
  background: #00513B;
  color: #fff;
}

select {
  border: 1px solid #000;
  color: black;
  padding: 10px;
}

v-col{
  border: 1px solid brown;
}
</style>
